import { Tab } from "@chakra-ui/react";
import { FeePostReviewBasisTabProps } from "features/fees/post/FeePostReviewBasisTabProps";
import {
  useFeeChargeEventBasisBreakdownBySecurityOwnershipRetrieveSuspense,
  useFeeChargeEventBasisBreakdownByUseRetrieveSuspense,
} from "gen/endpoints/fee-charge-event/fee-charge-event";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router";
import { PageTabBody } from "shared/components/layout/PageTabBody";
import { TableBox } from "shared/components/table/box/TableBox";
import { TableBoxBody } from "shared/components/table/box/TableBoxBody";
import { TableBoxHeader } from "shared/components/table/box/TableBoxHeader";
import { TableBoxTabs } from "shared/components/table/box/TableBoxTabs";
import { DataTable } from "shared/components/table/data/DataTable";
import { DataTableBoxActions } from "shared/components/table/data/DataTableBoxActions";
import { StylesForCellFn } from "shared/components/table/data/DataTableTypes";

export const FeePostReviewBasisBreakdownTab: React.FC = () => {
  const { t } = useTranslation(["fees"]);

  const { fundFamilyId, feeChargeEventId } =
    useOutletContext<Required<FeePostReviewBasisTabProps>>();

  const { data: basisBreakdownBySecurityOwnership } =
    useFeeChargeEventBasisBreakdownBySecurityOwnershipRetrieveSuspense(
      fundFamilyId,
      feeChargeEventId,
      {
        is_equalized_view: false,
      },
    );

  const { data: basisBreakdownByUse } =
    useFeeChargeEventBasisBreakdownByUseRetrieveSuspense(
      fundFamilyId,
      feeChargeEventId,
    );

  const tableDataArray = [
    basisBreakdownBySecurityOwnership,
    basisBreakdownByUse,
  ];
  const [selectedTab, setSelectedTab] = useState(0);

  return (
    <PageTabBody>
      <TableBox isFullWidth={true}>
        <TableBoxHeader>
          <TableBoxTabs index={selectedTab} onChange={setSelectedTab}>
            <Tab>{t("fees:postFees.feesBasisBreakdownByInvestorEntity")}</Tab>
            <Tab>{t("fees:postFees.feesBasisBreakdownByUse")}</Tab>
          </TableBoxTabs>
          <DataTableBoxActions />
        </TableBoxHeader>
        <TableBoxBody>
          <DataTable
            data={tableDataArray[selectedTab]}
            stylesForCell={stylesForCell}
          />
        </TableBoxBody>
      </TableBox>
    </PageTabBody>
  );
};

const stylesForCell: StylesForCellFn = ({ columnContext: { column } }) => {
  const { metadata } = column;
  if (metadata?.type === "fee_breakdown" && metadata.is_fee_basis_column) {
    return {
      backgroundColor: "gray.50",
      textAlign: "center",
    };
  }
};
